// extracted by mini-css-extract-plugin
export default {"root":"SocialLinks-module--root--f1dfb","normal":"SocialLinks-module--normal--8d778","white":"SocialLinks-module--white--ad9ab","shareTitle":"SocialLinks-module--shareTitle--a782a"};